var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStatusBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167.581,
    height: 8.14,
    viewBox: "0 0 167.581 8.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 26.861,
    height: 8.14,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904",
    transform: "translate(-23 -9.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M301.663,17.667h-.5a.5.5,0,0,0-.5.5V22.5a.5.5,0,0,0,.5.5h.5a.5.5,0,0,0,.5-.5V18.166A.5.5,0,0,0,301.663,17.667Zm-2.832,1.166h.5a.5.5,0,0,1,.5.5V22.5a.5.5,0,0,1-.5.5h-.5a.5.5,0,0,1-.5-.5V19.332A.5.5,0,0,1,298.831,18.833ZM297,20h-.5a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5h.5a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,0,297,20Zm-2.332,1h-.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,294.667,21Z",
    transform: "translate(-136.4 -7.253)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 10.495,
    height: 5.164,
    rx: 1,
    transform: "translate(178.673 10.497)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M359,21v2a1.084,1.084,0,0,0,0-2Z",
    transform: "translate(-169.083 -8.92)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 8.996,
    height: 3.665,
    rx: 1.333,
    transform: "translate(179.422 11.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M319.51,18.469a4.318,4.318,0,0,1,2.975,1.189.154.154,0,0,0,.217,0l.578-.583a.161.161,0,0,0,0-.228,5.446,5.446,0,0,0-7.536,0,.161.161,0,0,0,0,.228l.578.583a.154.154,0,0,0,.217,0A4.318,4.318,0,0,1,319.51,18.469Zm0,1.9a2.451,2.451,0,0,1,1.646.634.156.156,0,0,0,.217,0l.577-.583a.161.161,0,0,0,0-.229,3.578,3.578,0,0,0-4.874,0,.161.161,0,0,0,0,.229l.577.583a.155.155,0,0,0,.217,0A2.452,2.452,0,0,1,319.51,20.366Zm1.156,1.276a.156.156,0,0,1-.047.115l-1,1.007a.156.156,0,0,1-.221,0l-1-1.007a.157.157,0,0,1,.005-.228,1.71,1.71,0,0,1,2.208,0A.156.156,0,0,1,320.666,21.642Z",
    transform: "translate(-147.419 -7.085)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(23 9.437)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M37.055,23.44a3.925,3.925,0,0,1-.679,2.518,2.487,2.487,0,0,1-2.046.832,3.121,3.121,0,0,1-.746-.062v-.769a2.574,2.574,0,0,0,.7.1,1.787,1.787,0,0,0,1.386-.5,2.426,2.426,0,0,0,.5-1.57h-.047a1.379,1.379,0,0,1-.558.508,1.737,1.737,0,0,1-.761.156,1.536,1.536,0,0,1-1.191-.472,1.845,1.845,0,0,1-.433-1.3,1.981,1.981,0,0,1,.5-1.421,1.8,1.8,0,0,1,1.37-.531,1.82,1.82,0,0,1,1.761,1.16A3.357,3.357,0,0,1,37.055,23.44Zm-1.991-1.749a.886.886,0,0,0-.73.312,1.335,1.335,0,0,0-.254.871,1.165,1.165,0,0,0,.234.769.9.9,0,0,0,.718.277,1.142,1.142,0,0,0,.781-.277A.839.839,0,0,0,36.13,23a1.548,1.548,0,0,0-.137-.648,1.142,1.142,0,0,0-.375-.48A.92.92,0,0,0,35.064,21.691Zm2.726,4.533a.6.6,0,0,1,.148-.437.573.573,0,0,1,.429-.152.562.562,0,0,1,.433.16.6.6,0,0,1,.148.429.622.622,0,0,1-.152.441.656.656,0,0,1-.859,0A.624.624,0,0,1,37.789,26.224Zm0-3.334a.516.516,0,0,1,.578-.59.567.567,0,0,1,.437.156.614.614,0,0,1,.144.433.622.622,0,0,1-.152.441.656.656,0,0,1-.859,0A.624.624,0,0,1,37.789,22.89Zm5.966,2.577h-.769v1.245h-.894V25.467H39.485V24.76l2.608-3.772h.894v3.717h.769Zm-1.663-.761V23.272q0-.765.039-1.253H42.1a4.434,4.434,0,0,1-.344.625L40.34,24.705Zm4.713,2.007h-.917V23.026q0-.66.031-1.046-.09.094-.223.207t-.875.718l-.461-.582L46.041,21h.765Z",
    transform: "translate(-27.092 -18.322)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStatusBar);
export default __webpack_public_path__ + "static/media/app-status-bar.d10980c76010372ebf9862eabc7c3ac4.svg";
export { ForwardRef as ReactComponent };